// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"687":"de79290f","850":"0d66daa1"}[chunkId] + ".chunk.js";
};